import TokenLocker2 from 'contracts/abiTokenLocker2.json';
import TokenLocker3 from 'contracts/abiTokenLocker3.json';

const list = [
  {
    key: 0,
    address: '0x1Af8A578EDaa011504773881DA3cCf465c05472D',
    title: 'Public Round',
    abi: TokenLocker3.output.abi,
    isCountdown: true,
    communityRound: true
  },
  {
    key: 1,
    address: '0xeb86117313c7800f509D6da155a7EACd1496BcB7',
    title: 'Private Round',
    abi: TokenLocker3.output.abi,
    isCountdown: true,
    communityRound: true
  },
  {
    key: 2,
    address: '0x154fCA29De7578fF8d1DcF133b197ab7Ab8eF55F',
    title: 'Strategic Round',
    abi: TokenLocker3.output.abi,
    isCountdown: true,
    communityRound: true
  },
  {
    key: 3,
    address: '0x40450EdC90cF9bdC92b6e350148C71b05D60398c',
    title: 'Angel Round',
    abi: TokenLocker3.output.abi,
    isCountdown: true,
    communityRound: true
  }
];

export default list;
